import { render, staticRenderFns } from "./noticeBeforeExam.vue?vue&type=template&id=071d2b89&scoped=true&"
import script from "./noticeBeforeExam.vue?vue&type=script&lang=js&"
export * from "./noticeBeforeExam.vue?vue&type=script&lang=js&"
import style0 from "./noticeBeforeExam.vue?vue&type=style&index=0&id=071d2b89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d2b89",
  null
  
)

export default component.exports